import type { FormKitNode, FormKitPlugin } from '@formkit/core'

export function setFocus(): FormKitPlugin {
    return (node: FormKitNode) => {
        node.addProps(['focus'])

        node.props.focus = node.props.focus ? (typeof node.props.focus === 'string' ? node.props.focus : true) : false

        if (node.props.focus) {
            onMounted(() => {
                const focusInput = typeof node.props.focus === 'string' ? node.props.focus : node.props.id

                if (focusInput) {
                    const element = document.getElementById(focusInput)
                    if (element instanceof HTMLTextAreaElement || element instanceof HTMLInputElement) {
                        element?.setSelectionRange(element?.value.length, element?.value.length)
                        element?.focus()
                    }
                }
            })
        }
    }
}
